if ( !document.documentElement.classList.contains('supports-no-flexbox') ) {
  const fileInputs = document.querySelectorAll('.file-input-wrap input[type=file]');

  Array.prototype.forEach.call( fileInputs, function( input ) {
    const label = document.querySelector(`label[for="${input.id}"]`);
    const labelVal = label.innerHTML;
    const buttonText = 'choose a file...';
    let pseudoLabel = document.createElement('div');
    pseudoLabel.classList.add('pseudo-label');
    pseudoLabel.innerHTML = labelVal;
    input.parentNode.appendChild(pseudoLabel);
    label.innerHTML = buttonText;

    input.addEventListener('change', function( e ) {
      let fileName = '';

      if ( this.files && this.files.length > 1 ) {
        fileName = `${this.files.length} files selected`;
      } else {
        fileName = e.target.value.split( '\\' ).pop();
      }

      if ( fileName ) {
        label.classList.add('active');
        label.innerHTML = fileName;
      } else {
        label.classList.remove('active');
        label.innerHTML = buttonText;
      }
    });
  });
}

